import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

tippy("[data-tooltip-content]", {
    content: (reference: HTMLElement) => reference.dataset.tooltipContent,
    theme: "custom",
    maxWidth: 542,
});
